import CardLayout from '@/shared/components/cards/CardLayout';
import { BASE_URL_APP } from '@/shared/functions/Functions';
import Image from 'next/image';
import Link from 'next/link';

export default function Home() {
  return (
    <main className='d-flex justify-content-center'>
      <div className='col-4'>
        <CardLayout classCard='my-5 text-center'>
          <Image
            src='/images/influence-vision-logo.svg'
            alt='Next.js logo'
            width={180}
            height={76}
            priority
          />
          <div className='text-center mt-2'>
            <Link
              href={`${BASE_URL_APP}influencer/register/step/1`}
              className='btn btn-primary'
            >
              Register now
            </Link>
            <div className='mt-2'>
              <span className='text-muted mr-2'>
                Already have a profile?
                {/* {t('auth.already_have_profile')} */}
              </span>
              <Link href={BASE_URL_APP}>Login</Link>
            </div>
          </div>
        </CardLayout>
      </div>
    </main>
  );
}
